import { CREATECAT_ATTEMPT, CREATECAT_SUCCESS, CREATECAT_FAILED, RESET_CATS} from '../../actions/types'
const INITIAL_STATE = {
    loading: false,
    success: false,
    message: null,
    error: false,
}
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case CREATECAT_ATTEMPT:
            return { ...state, loading: true }
        case CREATECAT_SUCCESS:
            return { ...state, loading: false, success: true, message: action.message  }
        case CREATECAT_FAILED:
             return { ...state, loading: false, success: true,message: action.message ,error: true }
        case RESET_CATS:
             return { ...state, loading: false, success: false,message: null ,error: false }
       default:
            return state;
    }
}